"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductServiceImpl = void 0;
class ProductServiceImpl {
    constructor() {
        this.LOWERCASE_BUNDLE_IDENTIFIER = "bundle";
        this.utils = {
            isBundle: (productSKU) => {
                return productSKU.toLowerCase().includes(this.LOWERCASE_BUNDLE_IDENTIFIER);
            },
            extractSkuFromBundleSku: (bundleSKU) => {
                const bundleWordStartIndex = bundleSKU.toLowerCase().indexOf(this.LOWERCASE_BUNDLE_IDENTIFIER);
                return bundleWordStartIndex !== -1
                    ? bundleSKU.substring(0, bundleWordStartIndex + this.LOWERCASE_BUNDLE_IDENTIFIER.length)
                    : bundleSKU;
            }
        };
    }
}
exports.ProductServiceImpl = ProductServiceImpl;
//# sourceMappingURL=productServiceImpl.js.map